import { render, staticRenderFns } from "./AreaMeasurementField.vue?vue&type=template&id=706118a8"
import script from "./AreaMeasurementField.vue?vue&type=script&lang=ts"
export * from "./AreaMeasurementField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports